import { render, staticRenderFns } from "./SidebarEdit.vue?vue&type=template&id=c17100ea&scoped=true&"
import script from "./SidebarEdit.vue?vue&type=script&lang=js&"
export * from "./SidebarEdit.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEdit.vue?vue&type=style&index=0&id=c17100ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17100ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VSelect,VSwitch,VTextField})
